import { Component } from '@angular/core';

@Component({
  selector: 'customer-register',
  templateUrl: './custom-register.component.html',
  styleUrls: ['./custom-register.component.scss'],
})
export class CustomRegisterComponent {}
